import { AppRouteProps } from "@bsm/component";
import SignatureDetailsContainer from "./container/SignatureDetailsContainer";
import SignatoryCreateContainer from "../create/container/SignatoryCreateContainer";

export const SignatoryDetailsRoutes: Array<AppRouteProps> = [
    {
        path: ":id",
        element: <SignatureDetailsContainer />,
        children: [
            {
                path: "edit",
                element: <SignatoryCreateContainer />
            }
        ]
    },
];